module.exports = __webpack_public_path__ + "img/close.ac5bc2c1.png";